<nav class="nav-bar" role="navigation" aria-label="Main navigation">
  @for (item of items; track item.path) {
    <a
      class="nav-bar__tab"
      [routerLink]="item.path"
      routerLinkActive="nav-bar__tab--active"
      [routerLinkActiveOptions]="{ exact: true }"
      [attr.aria-label]="item.label"
    >
      <span class="nav-bar__label">{{ item.label }}</span>
    </a>
  }
</nav>
